import * as React from 'react';
import {
  PageTitle,
  PaginatorAndListSettings,
  Search,
  Section,
  useCacheQuery,
  useQueryOptionsFromSearchParams,
} from 'gossamer-front-end';
import { InstitutionProposal } from 'cb-model';

export const InstitutionProposalSearch = (): React.JSX.Element => {
  const [queryOptions, setQueryOptions] = useQueryOptionsFromSearchParams(InstitutionProposal);
  const gCacheQueryItem = useCacheQuery(InstitutionProposal, queryOptions);
  return (
    <>
      <PageTitle verb="Search" entity={InstitutionProposal} />
      <Section>
        <PaginatorAndListSettings
          entity={InstitutionProposal}
          gCacheQuery={gCacheQueryItem}
          queryOptions={queryOptions}
          render={Search}
          setQueryOptions={setQueryOptions}
        />
      </Section>
    </>
  );
};
